import {
  createEquipmentMutationGQL,
  updateEquipmentMutationGQL,
  archiveEquipmentMutationGQL,
} from './graphql';

export const OPEN_EQUIPMENT_MODAL = 'admin/equipmentList/OPEN_EQUIPMENT_MODAL';
export const CLOSE_EQUIPMENT_MODAL = 'admin/equipmentList/CLOSE_EQUIPMENT_MODAL';

export const openEquipmentModal = (equipment) => {
  return {
    type: OPEN_EQUIPMENT_MODAL,
    equipment,
  };
};

export const closeEquipmentModal = () => {
  return {
    type: CLOSE_EQUIPMENT_MODAL,
  };
};

export const dispatchCreateUpdateEquipment = (equipment) => {
  return async (dispatch, getState, { client }) => {
    if (equipment.id) {
      await updateEquipmentMutationGQL(client, equipment);
    } else {
      await createEquipmentMutationGQL(client, equipment);
    }
    dispatch(closeEquipmentModal());
  };
};

export const archiveEquipment = (equipmentId) => {
  return async (dispatch, getState, { client }) => {
    if (equipmentId) {
      await archiveEquipmentMutationGQL(client, equipmentId);
    }
    dispatch(closeEquipmentModal());
  };
};
